<script>
	const _ = require('underscore');
	const Q = require('q');
	const crudService = require('services/crudService');
	const productService = require('services/productService');
	const page = require('page');
	const assignmentService = require('services/assignmentService');
	const model = require('model/model');
	const utilities = require('utilities');

	const aadVocabUtilities = require('utilities/aadVocabUtilities');
	const getGraphicOrganizer = aadVocabUtilities.getGraphicOrganizer;

	const teacherPreviewUtilities = require('utilities/teacherPreviewUtilities');
	const createWorkspaceFromAssignment = teacherPreviewUtilities.createWorkspaceFromAssignment;

	let i18nMixin = require('i18n/i18nMixin.js');
	let userContext = require('core/userContext');

	const { getOfflineModeSetting, updateWorkspaceWithOfflineData } = require('utilities/offlineUtilities');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const WORKSPACE_TOOL_CLICK = analyticsUtilities.events.WORKSPACE_TOOL_CLICK;
	const ELL_AUDIO_PLAY = analyticsUtilities.events.ELL_AUDIO_PLAY;
	const ELL_AUDIO_PAUSE = analyticsUtilities.events.ELL_AUDIO_PAUSE;
	const ELL_AUDIO_COMPLETE = analyticsUtilities.events.ELL_AUDIO_COMPLETE;

	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		props: ['on-ready', 'route-context'],

		mixins: [i18nMixin],

		components: {
			'language-toggle': require('components/language-toggle.vue').default,
			'audio-player-simple': require('components/audio-player-simple.vue').default,
			'apple-icon': require('components/svg/apple-icon.vue').default,
			'lightning-icon': require('components/svg/lightning-icon.vue').default,
			'article-image': require('components/article-image.vue').default,
			'word-detective-tab': require('components/routes/student-workspace/word-detective-tab.vue').default,
			'meaning-mapper-tab': require('components/routes/student-workspace/meaning-mapper-tab.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'validated-input': require('components/validated-input.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},

		modelData: ['studentAssignmentsBackLink', 'activeProduct', 'articleDashboardTab', 'graphicOrganizer', 'offlineMode', 'offlineAssignments'],

		data() {
			let workspacePreviewClassCode = null;

			if (this.routeContext && this.routeContext.parsedPath && this.routeContext.parsedPath.getQueryParam) {
				workspacePreviewClassCode = this.routeContext.parsedPath.getQueryParam('classCode');
			}
			return {
				loading: false,
				workspace: null,
				assignmentId: this.routeContext.params.aid,
				editFocusWord: '',
				editDefinition: '',
				ELL_AUDIO_PLAY,
				ELL_AUDIO_PAUSE,
				ELL_AUDIO_COMPLETE,
				isTeacher: !userContext.isStudent(),
				workspacePreviewClassCode
			};
		},

		computed: {
			assignmentListState() {
				let assignmentListState = this.studentAssignmentsBackLink;
				let state = '#!';
				if (assignmentListState) {
					Object.keys(assignmentListState).forEach(k => {
						state += k + ':' + assignmentListState[k] + '/';
					});
				}

				return state;
			},
			ellFlag() {
				let workspace = this.workspace;
				let flag = null;
				if (workspace && workspace.opts.ell) {
					flag = userContext.getELLFlag();
				}
				return flag;
			},
			showDecodables() {
				const workspace = this.workspace;
				const product = this.activeProduct;

				if (!(workspace || product)) {
					return false;
				}

				return this.articleDashboardTab === 'decodables' && workspace.opts.decodables && product.dteGroups;
			},
			articleList() {
				let product = this.activeProduct;
				let workspace = this.workspace;
				let challenge = workspace ? workspace.opts.challenge : false;
				let support = workspace ? workspace.opts.support : false;
				let articles = [];
				let disabledArticles = [];
				let submittedArticles = [];
				let supplementalTypes = [];
				let tempArticleList = [];
				const showDecodables = this.showDecodables;

				if (workspace && product) {
					tempArticleList = [...product.articleList];

					if (showDecodables) {
						const assignedDteGroups = new Set(workspace.opts.decodables);
						tempArticleList = product.dteGroups.reduce((acc, group) => {
							if (assignedDteGroups.has(group.id)) {
								return [...acc, ...Object.values(group.articles)];
							}

							return acc;
						}, []);
					}

					// Categorize into submitted, disabled, and active
					tempArticleList.forEach((a, idx) => {
						let submitted = workspace.scoreState.a[a.uuid].s === 's';
						let disabled = this.isArticleDisabled(a, articles.length);
						let previewCC = this.workspacePreviewClassCode ? '?classCode=' + this.workspacePreviewClassCode : '';
						let href = '/student-workspace/' + this.routeContext.params.aid + '/' + a.uuid + previewCC + '#text';
						let article = _.assign({}, a, {
							href: !disabled ? href : false,
							submitted: submitted,
							disabled
						});
						if (submitted) {
							submittedArticles.push(article);
						} else if (disabled) {
							disabledArticles.push(article);
						} else {
							articles.push(article);
						}
					});

					// Mix in Supplemental Texts if optioned
					if (!showDecodables && support && product.supplemental_texts.support) {
						supplementalTypes.push('support');
					}
					if (!showDecodables && challenge && product.supplemental_texts.challenge) {
						supplementalTypes.push('challenge');
					}
					supplementalTypes.forEach(type => {
						let supplementalMap = product.supplemental_texts[type];
						let oneSupplementalActive = false;
						// Sort by PID to ensure deterministic order
						Object.keys(supplementalMap)
							.sort()
							.forEach((pid, idx) => {
								let article = supplementalMap[pid];
								let submitted = workspace.scoreState.a[article.uuid].s;
								let disabled = oneSupplementalActive;
								let href = '/student-workspace/' + this.routeContext.params.aid + '/' + article.uuid + '#text';

								if (!submitted && workspace.choice && !oneSupplementalActive) {
									oneSupplementalActive = true;
								}

								article = _.assign({}, article, {
									href: !disabled ? href : false,
									submitted: submitted,
									disabled,
									supplemental: true,
									challenge: type === 'challenge',
									support: type === 'support',
									first: idx === 0
								});

								if (submitted) {
									submittedArticles.push(article);
								} else if (disabled) {
									disabledArticles.push(article);
								} else {
									articles.push(article);
								}
							});
					});

					articles = articles.concat(disabledArticles).concat(submittedArticles);
				}
				return articles;
			},
			showSupplementalTexts() {
				let workspace = this.workspace;
				return workspace && (workspace.opts.challenge || workspace.opts.support) && this.articleDashboardTab !== 'decodables';
			},
			showMeaningMapperInit() {
				let graphicOrganizer = this.graphicOrganizer;
				let workspace = this.workspace;

				return workspace && workspace.opts.mm && graphicOrganizer && graphicOrganizer.nodes && graphicOrganizer.nodes.length === 0;
			},
			navItems() {
				let workspace = this.workspace;
				let graphicOrganizer = this.graphicOrganizer;
				let isTeacher = this.isTeacher;
				let items = [];
				let dashboardNav = {
					text: 'Articles',
					id: 'articles'
				};

				if (workspace && workspace.opts.wd) {
					items.push({
						text: 'Word Detective',
						id: 'word-detective-tab'
					});
				} else if (workspace && workspace.opts.mm && ((graphicOrganizer && graphicOrganizer.nodes && graphicOrganizer.nodes.length) || isTeacher)) {
					items.push({
						text: 'Meaning Mapper',
						id: 'meaning-mapper-tab'
					});
				}

				if (workspace && workspace.opts.decodables) {
					items.push({
						text: 'Decodables',
						id: 'decodables'
					});
				}

				if (items.length) {
					items.unshift(dashboardNav);
				}

				return items;
			},
			numberOfSubmittedArticles() {
				let articleList = this.articleList;
				let count = 0;

				if (articleList && articleList.length) {
					count = articleList.filter(a => a.submitted).length;
				}

				return count;
			},
			offlineAssignmentsMap() {
				let offlineAssignments = this.offlineAssignments;
				let userContextData = userContext.getUserData();
				let uid = userContextData ? userContextData.uid : null;
				let classCode = userContextData ? userContextData.classCode : null;
				let map = {};

				if (uid && offlineAssignments && offlineAssignments[uid]) {
					let allMap = offlineAssignments[uid];
					map = Object.keys(allMap).reduce((acc, aid) => {
						if (allMap[aid].cc === classCode) {
							acc[aid] = allMap[aid];
						}
						return acc;
					}, {});
				}
				return map;
			}
		},

		methods: {
			isArticleDisabled(article, index) {
				let workspace = this.workspace;
				let isDisabled = false;

				if (workspace && workspace.choice && workspace.choice.option) {
					// One at a time, only enable first index
					if (workspace.choice.option === 'o' && index === 0) {
						isDisabled = false;
					}
					// Two at a time, only enable first two indices
					else if (workspace.choice.option === 't' && (index === 0 || index === 1)) {
						isDisabled = false;
					}
					// Not one of the first "available" articles, disable
					else {
						isDisabled = true;
					}
				}

				return isDisabled;
			},
			setLanguage(code) {
				// Still call mixin provided method
				i18nMixin.methods.setLanguage.apply(this, arguments);
				let action_type = 'toggle_language';
				let tab = 'article-dashboard';
				let value = code;
				let pid = this.activeProduct.uuid || undefined;
				let aid = this.workspace.aid;
				let ss = model.get('splitScreen') || undefined;

				fireEvent(WORKSPACE_TOOL_CLICK, {
					action_type,
					state: value,
					tab,
					aid,
					pid,
					ss
				});
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		watch: {
			offlineAssignmentsMap(value) {
				let aid = this.routeContext.params.aid;
				let offlineMode = this.offlineMode;
				if (offlineMode && value && !value[aid]) {
					page('/student');
					pubsub.publish('message-error', 'Assignment not saved for offline.');
				}
			}
		},

		beforeDestroy() {
			model.set('activeProduct', null);
		},

		mounted() {
			let self = this;
			let routeContext = this.routeContext;
			let loadPrms = Q();

			if (!this.articleDashboardTab) {
				this.articleDashboardTab = 'articles';
			}

			this.loading = true;
			if (this.isTeacher) {
				if (this.workspacePreviewClassCode) {
					let dismissedAssignment = model.get('workspacePreviewModalAssignment') === this.assignmentId;
					let dismissedModal = model.get('workspacePreviewModalDismiss');
					if (!dismissedModal && !dismissedAssignment) {
						utilities.openModal('#modal-workspace-preview');
					}
					loadPrms = crudService
						.read('classAssignments', {
							aid: this.routeContext.params.aid,
							cc: this.workspacePreviewClassCode
						})
						.then(result => {
							let prms = Q(result);
							if (this.isTeacher) {
								prms = createWorkspaceFromAssignment(result).then(workspace => {
									this.workspace = workspace;
									return result;
								});
							}
							return prms;
						})
						.then(result => {
							return productService.get(result.p).then(product => {
								model.set('activeProduct', product);
								return this.workspace;
							});
						});
				} else {
					page('/student-authentication');
				}
			} else {
				let aid = routeContext.params.aid;
				loadPrms = Q.all([getOfflineModeSetting(), assignmentService.studentOpenWorkspace({ aid })])
					.spread((offlineMode, workspace) => {
						let prms = Q.reject();
						if (workspace) {
							if (workspace.as === 'd') {
								page('/student');
								pubsub.publish('message-error', 'Your teacher has just deleted that assignment');
							} else {
								model.remove('activeProduct');
								prms = productService.get(workspace.productId).then(function (product) {
									model.set('activeProduct', product);

									if (offlineMode) {
										return updateWorkspaceWithOfflineData(workspace).then(updatedWorkspace => {
											self.workspace = updatedWorkspace;
											return updatedWorkspace;
										});
									} else {
										self.workspace = workspace;
										return workspace;
									}
								});
								if (workspace.opts.mm) {
									prms.then(
										getGraphicOrganizer(routeContext.params.aid).then(data => {
											if (data && data.nodes && data.nodes.length === 0) {
												model.set('articleDashboardTab', 'meaning-mapper-tab');
											}
										})
									);
								}
							}
						} else {
							pubsub.publish('message-error', 'Failed to load assignment');
						}
						return prms;
					})
					.catch(error => {
						if (error.code === 1023) {
							// Class was deleted out from under you
							page('/logout');
						} else {
							page('/student');
						}
					});
			}
			loadPrms.then(() => (this.loading = false)).done();
		}
	};
</script>
<template>
	<main
		class="main article-dashboard"
		role="main">
		<header
			class="main-header"
			:class="{
				'-has-nav': navItems && navItems.length
			}">
			<div class="wrapper">
				<a
					v-if="!isTeacher"
					class="main-header-back"
					:href="`/student${assignmentListState}`">
					&larr; Assignments
				</a>
				<a
					v-if="isTeacher"
					class="main-header-back"
					:href="`/assignment/${workspacePreviewClassCode}/${assignmentId}/classresults`">
					&larr; Exit Preview
				</a>
				<h1 class="main-header-title">
					{{ activeProduct ? activeProduct.title : '' }}
				</h1>
				<div class="main-header-subtitle">
					<div class="product-type font-small text-muted">Article-A-Day</div>
					<div
						v-if="ellFlag && ellFlag !== 'en'"
						class="language-toggle-container">
						<language-toggle
							:set-language="setLanguage"
							:student-language="ellFlag">
						</language-toggle>
					</div>
				</div>
				<tab-container
					v-if="navItems && navItems.length"
					class="article-dash-nav main-header-nav print-hidden"
					model-key="articleDashboardTab"
					default-tab="articles">
					<button
						v-for="item in navItems"
						:key="item.id"
						:data-tab="item.id">
						{{ item.text }}
					</button>
				</tab-container>
			</div>
		</header>
		<div
			class="main-content wrapper"
			ref="articleDashboardTabPanel"
			:data-panel="articleDashboardTab">
			<load-mask v-if="loading"></load-mask>
			<template v-if="articleDashboardTab === 'articles' || showDecodables">
				<div
					class="aad-purpose margin-bottom-medium"
					:class="{
						'ell-rtl': i18n.rtl
					}">
					<template v-if="ellFlag">
						{{ i18n.raadELLPurpose }}
						<audio-player-simple
							v-if="offlineMode === false"
							:url="assetUrl(i18n.raadELLPurposeAudio)"
							:event-data="{
								pid: activeProduct.uuid,
								aid: routeContext.params.aid,
								lang: i18n.languageCode !== 'en' ? i18n.languageCode : undefined,
								tag: 'raad_ell'
							}"
							:audio-play-event-name="ELL_AUDIO_PLAY"
							:audio-pause-event-name="ELL_AUDIO_PAUSE"
							:audio-complete-event-name="ELL_AUDIO_COMPLETE">
						</audio-player-simple>
					</template>
					<template v-if="!ellFlag && !showDecodables">
						Words are where humans store knowledge. So you will build your knowledge by reading these articles. You will also increase your vocabulary,
						improve your reading stamina, and enjoy reading every day!
					</template>
				</div>
				<div
					v-if="ellFlag"
					:class="{
						'ell-rtl': i18n.rtl
					}">
					{{ i18n.raadELLChooseOne }}
					<audio-player-simple
						v-if="offlineMode === false"
						:url="assetUrl(i18n.raadELLChooseOneAudio)"
						:event-data="{
							pid: activeProduct.uuid,
							aid: routeContext.params.aid,
							lang: i18n.languageCode !== 'en' ? i18n.languageCode : undefined,
							tag: 'raad_ell'
						}"
						:audio-play-event-name="ELL_AUDIO_PLAY"
						:audio-pause-event-name="ELL_AUDIO_PAUSE"
						:audio-complete-event-name="ELL_AUDIO_COMPLETE">
					</audio-player-simple>
				</div>
				<div v-else>Please choose one article to read now.</div>
				<div class="padding-none margin-top-large article-list">
					<div
						v-if="showMeaningMapperInit"
						class="mask"></div>
					<template v-for="(article, index) in articleList">
						<a
							v-if="workspace.scoreState.a[article.uuid]"
							:href="article.href"
							class="article-card"
							:class="{
								disabled: article.disabled,
								supplemental: article.supplemental,
								submitted: article.submitted,
								first: article.first
							}">
							<div class="article-card-inner">
								<div class="image-container">
									<article-image
										v-if="article.thumbnail"
										:image-url="article.thumbnail"
										:alt-text="article.imgAlt">
									</article-image>
									<div
										class="submitted-banner text-ellipsis"
										v-if="article.submitted">
										SUBMITTED
									</div>
								</div>
								<div class="metadata-container">
									<strong class="article-title">{{ article.title }}</strong>
									<div class="article-info">
										{{ article.wordCount }} words
										<template v-if="article.supplemental">
											| {{ article.challenge ? 'Challenge' : 'Boost' }} Article
											<div class="icon-row">
												<apple-icon v-if="article.support"></apple-icon>
												<lightning-icon v-if="article.challenge"></lightning-icon>
											</div>
										</template>
									</div>
								</div>
							</div>
						</a>
					</template>
				</div>
				<div
					v-if="showSupplementalTexts"
					class="supplemental-key">
					<div class="key-item challenge">
						<lightning-icon></lightning-icon>
						<div class="key-text">
							<div class="key-title">Challenge Article</div>
							<div class="key-subtitle">Try these articles if you are really interested in this topic or know a lot about it.</div>
						</div>
					</div>
					<div class="key-item support">
						<apple-icon></apple-icon>
						<div class="key-text">
							<div class="key-title">Boost Article</div>
							<div class="key-subtitle">Try these articles if you get stuck.</div>
						</div>
					</div>
				</div>
			</template>
			<word-detective-tab
				v-if="articleDashboardTab === 'word-detective-tab'"
				:aid="routeContext.params.aid"
				:product="activeProduct"
				:demo="isTeacher">
			</word-detective-tab>
			<meaning-mapper-tab
				v-if="articleDashboardTab === 'meaning-mapper-tab'"
				:aid="routeContext.params.aid"
				:product="activeProduct"
				:number-of-submitted-articles="numberOfSubmittedArticles"
				:demo="isTeacher"
				:assignment-options="workspace && workspace.opts">
			</meaning-mapper-tab>
		</div>
	</main>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/flexbox';
	@import 'config/variables';

	main.main.article-dashboard {
		.aad-purpose {
			font-weight: bold;
			font-size: 0.875rem;
		}

		.article-list {
			position: relative;
			display: flex;
			flex-wrap: wrap;

			.article-card {
				flex-basis: 100%;
				padding: 0.5rem;

				.article-card-inner {
					display: flex;
					align-items: center;
				}

				.image-container {
					position: relative;

					.submitted-banner {
						position: absolute;
						bottom: 0;
						background-color: $c-blue;
						color: $c-white;
						z-index: 1;
						width: 100%;
						text-align: center;
					}
				}

				.metadata-container {
					padding: 0.5rem;

					.article-info {
						.icon-row {
							.lightning-icon {
								stroke: $c-blue;
							}

							.apple-icon {
								stroke: $c-blue;
							}
						}
					}
				}

				&.supplemental {
					.article-card-inner {
						background-color: $c-blue-lighter;
					}
				}

				&.disabled {
					opacity: 0.4;
				}
			}
		}

		.supplemental-key {
			display: flex;
			flex-wrap: wrap;
			margin-top: 2rem;

			.key-item {
				flex-basis: 100%;
				display: flex;
				margin-bottom: 1rem;

				svg {
					margin: 0.5rem 1rem;
				}

				.key-text {
					flex: 1;

					.key-title {
						font-weight: 500;
					}
				}

				&.challenge svg {
					stroke: $c-blue;
				}

				&.support svg {
					stroke: $c-blue;
				}
			}
		}

		.mask {
			position: absolute;
			z-index: 2;
			top: 0;
			bottom: 0;
			background-color: $c-grey;
			opacity: 0.7;
			right: 0;
			left: 0;
		}

		.image {
			display: block;
			width: 100%;
			height: 100%;
			background-size: cover;
		}

		h1.main-header-title,
		.main-header-back {
			float: none;
		}

		.main-header-back {
			display: none;
		}

		.main-header-title {
			display: block;
		}

		div.main-header-subtitle {
			display: flex;
			line-height: 1;

			.product-type {
				flex: 1;
			}
		}

		.main-header .wrapper,
		.main-content.wrapper {
			max-width: $max-width;
		}

		.meaning-mapper-init {
			background-color: $c-blue-light;
			border-radius: 4px;
			padding: 1rem;
			max-width: 20rem;
			margin: 0 auto;

			form.validated-form {
				input[type='text']:not(.date-input) {
					border-color: $c-slate;

					&,
					& + label,
					& + label:before {
						background-color: transparent;
					}
				}
			}
		}
	}

	.ell-rtl {
		direction: rtl;
	}

	@media only screen and (min-width: $bp-width-med) {
		main.main.article-dashboard {
			.main-header-back {
				margin-bottom: 0rem;
				display: inline-block;
			}

			.article-list {
				.article-card {
					flex-basis: 360px;

					.article-card-inner {
						align-items: inherit;
					}
				}
			}

			.supplemental-key .key-item {
				flex-basis: 360px;
			}
		}
	}
</style>
